<template>
  <div class="mb-2 sub-menu">
    <b-button
      :id="menu.routeName"
      :variant="
        $route.meta.navActiveTab == menu.active ? `primary` : `outline-primary`
      "
      v-for="menu in menus"
      :key="`menu-${menu.routeName}`"
      class="mr-1"
      @click="
        $router.push({ name: menu.routeName, params: { id: $route.params.id } })
      "
    >
      {{ $t(menu.label) }}
    </b-button>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";

export default {
  components: {
    BButton,
  },
  data() {
    return {
      menus: [
        {
          routeName: "update-player",
          active: "update-player",
          label: "breadcrumb.updatePlayer",
        },
        {
          routeName: "list-player-block-number",
          active: "player-block-number",
          label: "breadcrumb.blockNumber",
        },
        {
          routeName: "list-player-allow-number",
          active: "player-allow-number",
          label: "breadcrumb.allowNumber",
        },
        {
          routeName: "list-player-sell-out",
          active: "player-sell-out",
          label: "breadcrumb.sellOut",
        },
        {
          routeName: "list-player-bet-setting",
          active: "player-bet-setting",
          label: "breadcrumb.betSetting",
        },
      ],
    };
  },
  mounted() {
    this.scrollToMenu();
  },
  methods: {
    scrollToMenu() {
      setTimeout(() => {
        const element = document.getElementById(this.$route.name);
        element.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }, 200);
    },
  },
  setup() {},
};
</script>